var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: _vm.multiple,
        "no-data-text": "No tienes destinos",
        data: _vm.destinations
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c("vs-td", { attrs: { data: data[indextr].destination } }, [
                    _vm._v(" " + _vm._s(tr.destination) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr] } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          tr.departureTime && "Hora: " + tr.departureTime
                        ) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(
                      " " +
                        _vm._s(
                          tr.mileageOutput && "Kilometraje: " + tr.mileageOutput
                        ) +
                        " "
                    )
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr] } }, [
                    _vm._v(
                      " " +
                        _vm._s(tr.arrivalTime && "Hora: " + tr.arrivalTime) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(
                      " " +
                        _vm._s(
                          tr.mileageArrival &&
                            "Kilometraje: " + tr.mileageArrival
                        ) +
                        " "
                    )
                  ])
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.destinationsSelected,
        callback: function($$v) {
          _vm.destinationsSelected = $$v
        },
        expression: "destinationsSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Destino")]),
          _c("vs-th", [_vm._v("Salida")]),
          _c("vs-th", [_vm._v("Llegada")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }